import React, { useState } from "react";
import useStyles from "./styles";
import { ImageInput, Input, InputMeasurement, PhoneInput, Select } from "Components/Form";
import HorizontalInput from "Components/Form/HorizontalInput";
import { Logo } from "Models/company";
import { Brand } from "Models/brand";
import InputDateRange from "Components/Form/Input/DateRange";
import { Range } from "react-date-range";
import { SearchNormal1 } from "iconsax-react";
import { Measurement } from "Models/measurement";
import InputRange from "Components/Form/InputRange";
import LabelForm from "Components/Form/Label";
import MapInput from "Components/Form/MapInput";
import { Location } from "Models/location";
import TextAreaForm from "Components/Form/TextArea";
import TextFieldInputComponent from "Components/Form/TextFieldInputComponent/TextFieldInputComponent";

export default function InputSection() {
  const [horizontalInputValue, setHorizontalInputValue] = useState("");
  const [from, setFrom] = useState<Date>();
  const [to, setTo] = useState<Date>();
  const [brand, setBrand] = useState<Brand>();
  const [error, setError] = useState(false);
  const [name, setName] = useState<string>("");
  const [number, setNumber] = useState<string>();
  const [weight, setWeight] = useState<number>(1500);
  const [quantity, setQuantity] = useState<number>(1);
  const [selectedLocation, setSelectedLocation] = useState<Location | null>(null);
  const [phone, setPhone] = useState("");

  const classes = useStyles();

  const measurement: Measurement = {
    id: 1,
    name: "weight",
    code: "kg",
    decimalPlaces: 2,
  };

  return (
    <>
      <div>
        <div>
          <LabelForm className={classes.formLabel}>HorizontalInput</LabelForm>
        </div>
        <HorizontalInput
          name="userName"
          label="label"
          placeholder="HorizontalInput"
          value={horizontalInputValue}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setHorizontalInputValue(e.target.value);
            setError(e.target.value.trim() === "");
          }}
          error={!horizontalInputValue}
          errorMessage="errorMessage"
        />
        <hr />
      </div>
      <div>
        <ImageInput
          id={"image-input"}
          title="ImageInput"
          onChangeLogo={(logo?: Logo) => {
            setBrand(
              brand
                ? {
                    ...brand,
                    logo,
                  }
                : ({ logo } as Brand)
            );
          }}
          showActionButtons={true}
          maxAllowedSizeMb={10}
          allowedImageExtensions={["jpg", "jpeg", "png"]}
        />
        <hr />
      </div>
      <div>
        <div>
          <LabelForm className={classes.formLabel}>InputDateRange</LabelForm>
        </div>
        <InputDateRange
          label="filled"
          name="custom-period"
          onChange={(range: Range) => {
            setFrom(range?.startDate);
            setTo(range?.endDate);
          }}
          pEndDate={to}
          pStartDate={from}
          variant="filled"
        />
        <InputDateRange
          label="outlined"
          name="custom-period"
          onChange={(range: Range) => {
            setFrom(range?.startDate);
            setTo(range?.endDate);
          }}
          pEndDate={to}
          pStartDate={from}
          variant="outlined"
        />
        <InputDateRange
          label="standard"
          name="custom-period"
          onChange={(range: Range) => {
            setFrom(range?.startDate);
            setTo(range?.endDate);
          }}
          pEndDate={to}
          pStartDate={from}
          variant="standard"
        />
        <hr />
      </div>
      <div>
        <div>
          <LabelForm className={classes.formLabel}>Input</LabelForm>
        </div>
        <Input
          label="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="text"
          required
          type="text"
          error={!name}
          errorMessage={!name ? "Error field" : ""}
        />
        <Input
          label="radio"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="radio"
          required
          type="radio"
          error={!name}
          errorMessage={"Error field"}
        />
        <Input
          type="number"
          label="number"
          required
          value={number}
          onChange={(e) => setNumber(e.target.value)}
          step={1}
          placeholder="Input number"
        />
        <hr />
      </div>
      <div>
        <InputMeasurement
          label="InputMeasurement"
          value={weight}
          showMeasurement={true}
          change={(newWeight) => setWeight(newWeight)}
          measurement={measurement}
          required
          error={!weight}
          errorMessage="error InputMeasurement"
        />
        <hr />
      </div>
      <div>
        <InputRange
          label={"InputRange"}
          value={quantity}
          change={(value: number) => setQuantity(value)}
          error={quantity < 10 ? true : false}
          errorMessage={"error InputRange"}
          range={1}
          onlyIntValues
        />
        <hr />
      </div>
      <div>
        <MapInput
          label="MapInput"
          placeholder="MapInput"
          showMapIcon
          location={selectedLocation || undefined}
          onChange={(location) => {
            setSelectedLocation(location as Location);
          }}
        />
        <hr />
      </div>
      <div>
        <PhoneInput
          label="PhoneInput"
          required
          defaultCountry="BR"
          value={phone}
          onChange={(value) => {
            setPhone(value);
            value && value.length <= 10 ? setError(true) : setError(false);
          }}
          error={error}
          errorMessage="errorMessage"
        />
        <hr />
      </div>
      <div>
        <div>
          <LabelForm className={classes.formLabel}>TextAreaForm</LabelForm>
        </div>
        <TextAreaForm
          name="TextAreaForm"
          placeholder="TextAreaForm"
          value={name}
          onChange={(e) => setName(e.target.value)}
          error={!!error}
          errorMessage={error}
          register={undefined}
        />
        <hr />
      </div>
      <div>
        <TextFieldInputComponent
          label="TextFieldInputComponent"
          placeholder="TextFieldInputComponent"
          initialValue={name}
          onChange={(value) => setName(value)}
          leftIcon={<SearchNormal1 />}
          helperText={name.length < 3 ? "helperText" : ""}
          required
        />
        <hr />
      </div>
    </>
  );
}
